import { GlobalOutlined } from "@ant-design/icons";

import { localeLabel, orderLocales } from "@/shared/utils/locale.utils";

import style from "./style.module.css";

interface LanguageChipsProps {
  /** The locales to display; injected as the field value when rendered as a Form.Item child. */
  value?: string[];
  id?: string;
  "aria-labelledby"?: string;
  "aria-describedby"?: string;
}

// Read-only companion to LanguagesField: globe chips for the languages a record already has.
export default function LanguageChips({
  value = [],
  id,
  "aria-labelledby": ariaLabelledby,
  "aria-describedby": ariaDescribedby,
}: LanguageChipsProps) {
  return (
    <ul id={id} className={style.languageList} aria-labelledby={ariaLabelledby} aria-describedby={ariaDescribedby}>
      {orderLocales(value).map((locale) => (
        <li key={locale} className={style.languageChip}>
          <GlobalOutlined aria-hidden="true" /> {localeLabel(locale)}
        </li>
      ))}
    </ul>
  );
}
